// extracted by mini-css-extract-plugin
export var chevronIcon = "_dv-2";
export var teamName = "_dv-1";
export var teamSwitcherButton = "_dv-0";